// @react-functional
import { useState, useEffect } from 'react';

import {
  getFiltersCount,
  searchWithinRestrictedArticles,
} from '../../../legislation.api';
import { useUser } from '../../../../../user/useUser';
import { parliamentaryQuestionsFilter } from '../utils/constants';

import {
  SearchAPIResponse,
  SearchParams,
} from '../../../../../search/search.types';
import {
  getCASSAggregation,
  getCEAggregation,
  getLegislativeFolderAggregation,
} from '../components/search-query-section/utils/utils';

export const useSearchWithinRestrictedArticles = (
  params: SearchParams,
  initialVersionId: string = '',
) => {
  const [data, setData] = useState<SearchAPIResponse | null>(null);
  const [filters, setFilters] = useState({});
  const {
    loggedIn,
    currentUser: { featureFlags },
  } = useUser();

  useEffect(() => {
    const fetchData = async () => {
      const result = await searchWithinRestrictedArticles(params, loggedIn);
      // We need to make an additional call for commentary in order to get parliamentary questions
      // since this is a sub-filter
      if (params.type === 'commentary') {
        const count = await getFiltersCount(
          { ...params, publisher: parliamentaryQuestionsFilter },
          initialVersionId,
          loggedIn,
        );
        setFilters({ pq: count.pq, bofip: count.bofip });
      } else if (params.type === 'arret') {
        setFilters({
          cass: getCASSAggregation(result.aggregations),
          ce: getCEAggregation(result.aggregations),
        });
      } else {
        setFilters({
          legislativeFolder: getLegislativeFolderAggregation(
            result.aggregations,
          ),
        });
      }
      setData(result);
    };

    // Preparatory work are currently in beta, only given customers have access to it
    if (
      params.type === 'preparatory_work' &&
      !featureFlags.includes('preparatory_work')
    ) {
      return;
    }

    fetchData();
  }, []);

  return { data, filters };
};
